import ThemeSelectView from './ThemeSelectView';
import CensusToggle from './CensusToggle';
import CompareToggle from './CompareToggle';
import StateSelect from './StateSelect';
import YearSelect from './YearSelect';
import ResetButton from './ResetButton';

export default function DataControls(props) {
    const { type } = props;
    const tab = type.label.toLowerCase();
    if (tab === 'more info') return null;
    return (
        <div id="data-controls" role="toolbar" aria-label={'Data Selections'} className="control">
            <div className="grid-wrap">
                <ThemeSelectView />
                <CompareToggle />
                <StateSelect />
                <CensusToggle />
                <YearSelect />
                <ResetButton />
            </div>
        </div>
    );
}
